import { ReactElement, ReactNode } from "react";

import DeleteModalImage from "../../assets/delete-modal.svg";

interface DeleteModalProps {
  onCancel: () => void;
  text: string;
  subText: string;
  onConfirm?: () => void;
  notDelete?: boolean;
  icon?: string;
  /** Extra content between the message and the buttons (e.g. a required input). */
  children?: ReactNode;
  /** Confirm button label. Defaults to the existing "Confirm". */
  confirmText?: string;
  /** Blocks confirming while a required input is missing or a call is running. */
  confirmDisabled?: boolean;
}

const DeleteModal: React.FC<DeleteModalProps> = ({
  onCancel,
  text,
  subText,
  onConfirm,
  notDelete = false,
  icon = null,
  children,
  confirmText,
  confirmDisabled = false,
}: DeleteModalProps): ReactElement => {
  return (
    <div className="modal-container flex flex-col items-center justify-center">
      <img
        src={icon ? icon : DeleteModalImage}
        alt="kamco delete delete-customer"
      />
      <h3>{text}</h3>
      <p style={{ textAlign: "center" }}>{subText}</p>
      {children}
      <div className="buttons-container flex items-center justify-between">
        <button
          className="cancel flex items-center justify-center"
          onClick={onCancel}
        >
          Cancel
        </button>
        {notDelete ? (
          <button
            className="flex items-center justify-center"
            onClick={onConfirm}
          >
            View assigned users
          </button>
        ) : (
          <button
            className="flex items-center justify-center"
            onClick={onConfirm}
            disabled={confirmDisabled}
          >
            {confirmText ?? "Confirm"}
          </button>
        )}
      </div>
    </div>
  );
};

export default DeleteModal;
